import { omit } from 'lodash-es';
import { default as Upload } from 'ant-design-vue/lib/upload/Upload';
import { remove } from 'lodash-es';
import { ConfigConsumerProps } from '../config-provider/configConsumerProps';
import { clone } from 'lodash-es';
export default {
  name: 'FcUpload',
  props: {
    fileList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    showUploadList: {
      type: Boolean,
      default: true,
    },
    original: {
      type: Boolean,
      default: false,
    },

    template: {
      type: String,
      default: '',
    },
    // download: {
    //   type: Boolean,
    //   default: true,
    // },
    // deleteIcon: {
    //   type: Boolean,
    //   default: true,
    // },
    uploadListConfig: {
      type: Object,
      default: () => {
        return {
          download: true,
          canRemove: true,
        };
      },
    },
    draggable: {
      type: Boolean,
      default: false,
    },
    uploadStatus: {
      type: String,
      default: 'loading',
    },
    defaultSelectedIndex: {
      type: Number,
      default: null,
    },
    text: String,
    ...Upload.props,
  },
  watch: {
    fileList(newVal) {
      this.uploadedList = clone(this.fileList);
      this.list = clone(this.fileList);
      this.uploadedList.forEach(item => {
        item.isDefault = true;
      });
      this.list.forEach(item => {
        item.isDefault = true;
      });
    },
    defaultSelectedIndex: {
      immediate: true, // 立即执行
      deep: true,
      handler() {
        if (this.defaultSelectedIndex !== null && this.defaultSelectedIndex !== undefined) {
          this.selectedIndex = this.defaultSelectedIndex || 0;
        }
      },
    },
  },
  inject: {
    configProvider: { default: () => ConfigConsumerProps }, // 注入依赖，包含组件基本class名方法
  },
  data() {
    return {
      uploadedList: [],
      draggedItemIndex: 0,
      list: [],
      selectedIndex: null, //当前选中的文件节点
    };
  },
  mounted() {
    if (this.fileList && this.fileList.length > 0) {
      this.uploadedList = clone(this.fileList);
      this.list = clone(this.fileList);
    }
  },
  methods: {
    handleChange(info) {
      let resultHint = false;
      if (!this.original) {
        const foundObject = this.uploadedList.find(obj => obj.uid === info.file.uid);
        if (!foundObject) {
          info.file.isProgress = true;
          this.uploadedList.push(info.file);
        } else {
          if (info.event && info.event.percent) {
            foundObject.percent = info.event.percent;
            foundObject.isProgress = true;
          } else {
            foundObject.status = info.file.status;
            foundObject.response = info.file.response;
            foundObject.isProgress = false;
          }
        }
        // 对 uploadedList 数组进行过滤操作
        remove(this.uploadedList, e => {
          if (e.isDefault) {
            return false;
          }
          if (
            (e.status == 'done' || e.status == 'error') &&
            e.response &&
            e.response.code != '200'
          ) {
          }
          return (
            (e.status == 'done' || e.status == 'error' || !e.status) &&
            ((e.response && e.response.code != '200') || !e.response)
          );
        });

        let list = [...info.fileList]; // 对 uploadedList 数组进行过滤操作
        list = list.filter(e => {
          if (!e.isDefault) {
            if (
              (e.status == 'done' || e.status == 'error') &&
              e.response &&
              e.response.code != '200'
            ) {
              this.$abNotification.error({
                message: `操作失败`,
                description: `${e.response.message}`,
              });
              resultHint = true;
              return false; // 返回 false，表示当前元素被移除
            }
          }
          return true; // 返回 true，表示当前元素保留在数组中
        });
        this.list = list;
      } else {
        this.uploadedList = [...this.uploadedList, ...info.fileList];
      }
      info.fileList = this.list;
      if (!resultHint && info.fileList.every(c => c.status == 'done')) {
        this.$abNotification.success({
          message: `操作成功`,
          description: `附件上传成功!`,
        });
      }
      this.$emit('change', info);
    },
    async before(file, fileList) {
      // 判断格式是否是支持的
      const fileType = file.name
        .trim()
        .split('.')
        .pop()
        .toLowerCase();
      if (
        this._props.accept &&
        this._props.accept != '*' &&
        !this._props.accept
          .trim()
          .replace(/\./g, '')
          .split(',')
          .includes(fileType)
      ) {
        this.$abNotification.error({
          message: `提示`,
          description: `文件“${file.name}”上传失败，格式不正确！`,
        });
        return Promise.reject();
      }
      let returnValue = true;
      if (!this.$listeners.before) {
        returnValue = true;
        this.list = [...this.list, file];
        return returnValue ? Promise.resolve() : Promise.reject();
      } else {
        returnValue = await new Promise((resolve, reject) => {
          this.$emit('before', file, fileList, this.list, data => {
            resolve(data); // 或者 reject(data);
          });
        });
        //如果是阻拦掉的 不放入已上传列表
        if (returnValue) {
          this.list = [...this.list, file];
        }
        return returnValue ? Promise.resolve() : Promise.reject();
      }
    },
    // 点击叶子节点的回调
    clickFile(item) {
      this.$emit('clickFile', item);
    },
    deleteFile(item, event) {
      event.stopPropagation();
      this.uploadedList = this.uploadedList.filter(file => file.uid !== item.uid);
      this.list = this.list.filter(file => file.uid !== item.uid);
      this.$emit('deleteFile', { item, fileList: this.uploadedList });
    },
    downloadFile(item) {
      if (item.originFileObj) {
        const file = item.originFileObj;
        const blob = new Blob([file], { type: file.type });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = file.name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      } else {
        this.$abNotification.warning({
          message: '文件下载',
          description: '该文件无法下载！',
        });
      }
    },
    drop(newIndex) {
      const draggedItem = this.uploadedList[this.draggedItemIndex];
      this.uploadedList.splice(this.draggedItemIndex, 1);
      this.uploadedList.splice(newIndex, 0, draggedItem);
    },
    dragOver(ev) {
      ev.preventDefault();
    },
    drag(index) {
      this.draggedItemIndex = index;
    },
    uploadedClick(file, index) {
      this.selectedIndex = index;
      this.$emit('clickFile', file);
    },
  },
  render() {
    const {
      _props,
      $listeners,
      uploadedList,
      text,
      showUploadList,
      deleteFile,
      template,
      uploadListConfig,
      drag,
      drop,
      dragOver,
      draggable,
      uploadStatus,
      selectedIndex,
      list,
      $slots,
      $scopedSlots,
    } = this;
    const { getPrefixCls, locale } = this.configProvider;
    const prefixCls = getPrefixCls('', 'fc-upload');
    uploadListConfig.download =
      uploadListConfig.download === undefined ? true : uploadListConfig.download;
    uploadListConfig.canRemove =
      uploadListConfig.canRemove === undefined ? true : uploadListConfig.canRemove;
    return (
      <div class={prefixCls}>
        <a-upload
          {...{ props: omit(_props, 'showUploadList', 'fileList', 'beforeUpload') }}
          {...{ on: omit($listeners, 'change') }}
          showUploadList={false}
          fileList={list}
          beforeUpload={this.before}
          onChange={this.handleChange}
        >
          {$slots && $slots.content ? (
            <span>{$slots.content}</span>
          ) : (
            <div class={`${prefixCls}-button`}>{text || '上传文件'}</div>
          )}
        </a-upload>
        {template && (
          <a class={`${prefixCls}-download`} href={template} download target="_blank">
            {locale.Upload.downloadTemplate}
          </a>
        )}
        {showUploadList && uploadedList && uploadedList.length > 0 && (
          <div class="fileList">
            <ul>
              {uploadedList &&
                uploadedList.length > 0 &&
                uploadedList.map((item, index) => (
                  <div class="fileBlock">
                    <li
                      class="file"
                      key={item.uid}
                      draggable={draggable}
                      onDragstart={() => drag(index)}
                      onDragover={event => dragOver(event)}
                      onDrop={event => drop(index)}
                      onClick={() => this.uploadedClick(item, index)}
                    >
                      <div
                        class={`leftInfo ${index === selectedIndex ? 'selectedFile' : ''} ${
                          uploadListConfig.canRemove || uploadListConfig.canRemove === undefined
                            ? 'maxInfo'
                            : ''
                        }`}
                      >
                        <div class="linkFileName">
                          <fc-icon
                            className={
                              uploadListConfig.fileIcon ? uploadListConfig.fileIcon : 'FCwenjian'
                            }
                            size="16px"
                            color={
                              uploadListConfig.fileIconColor
                                ? uploadListConfig.fileIconColor
                                : '#4e5969'
                            }
                          ></fc-icon>
                          {$scopedSlots.tag && (
                            <span class="tag">
                              {$scopedSlots.tag ? $scopedSlots.tag(item) : null}
                              {/* <slot name="tag" rowData={item}></slot> */}
                            </span>
                          )}
                          <div class="fileName" title={item.name}>
                            {item.name}
                          </div>
                        </div>
                        {/* {item.isProgress && uploadStatus==='progress' && (
                        <a-progress percent={item.percent} showInfo={false} class="progress" />
                      )} */}
                        {item.isProgress && uploadStatus === 'loading' && (
                          <a-icon type="loading" class={`${prefixCls}-icon`} />
                        )}
                        {!item.isProgress && uploadListConfig.download && (
                          <fc-icon
                            onClick={() =>
                              uploadListConfig.onDownload
                                ? uploadListConfig.onDownload(item)
                                : this.downloadFile(item)
                            }
                            class={`${prefixCls}-icon`}
                            className={
                              uploadListConfig.downloadIcon
                                ? uploadListConfig.downloadIcon
                                : 'FCdownload-2'
                            }
                            size="16px"
                            color={
                              uploadListConfig.downloadIconColor
                                ? uploadListConfig.downloadIconColor
                                : '#4e5956'
                            }
                          ></fc-icon>
                        )}
                      </div>
                      {(uploadListConfig.canRemove || uploadListConfig.canRemove === undefined) && (
                        <fc-icon
                          class="deleteIcon"
                          className={
                            uploadListConfig.removeIcon ? uploadListConfig.removeIcon : 'FCshanchu'
                          }
                          onClick={e => deleteFile(item, e)}
                          size="16px"
                          color={
                            uploadListConfig.removeIconColor
                              ? uploadListConfig.removeIconColor
                              : '#F53F3F'
                          }
                        ></fc-icon>
                      )}
                    </li>
                    {item.isProgress && uploadStatus === 'progress' && (
                      <div class="progressLine">
                        <a-progress percent={item.percent} showInfo={false} class="progress" />
                        {(uploadListConfig.canRemove ||
                          uploadListConfig.canRemove === undefined) && <div class="space"></div>}
                      </div>
                    )}
                  </div>
                ))}
            </ul>
          </div>
        )}
      </div>
    );
  },
};
